import React from "react";
import { TfiClose } from "react-icons/tfi";

const Model = ({ closeModal, title, children, isForm, loading,handleSubmit }) => {
  return (
    <div className="fixed inset-0 bg-foreground/60 flex justify-center items-center z-50 p-4 sm:p-6 font-sans">
      <div 
        className="absolute inset-0 bg-transparent z-40"
        onClick={closeModal} 
      />
      <div className="modal-content bg-card rounded-xl border border-border shadow-theme p-5 sm:p-6 w-full max-w-2xl max-h-[calc(100dvh-2rem)] sm:max-h-[90dvh] overflow-y-auto custom-scrollbar relative z-50">
        <div className="h-1.5 card-gradient-strip -m-5 sm:-m-6 mb-4 sm:mb-5 rounded-t-xl" />
        <div className="flex justify-between items-center gap-3">
          <h2 className="font-heading text-base sm:text-xl font-bold text-primary tracking-tight truncate">{title}</h2>
          <button
            onClick={closeModal}
            aria-label="Close"
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary text-primary transition-all duration-300 hover:text-accent"
          >
            <TfiClose />
          </button>
        </div>
        <hr className="my-3 border-border" />
        {isForm === true ? (
          <form onSubmit={handleSubmit}>
            {children}
            <div className="flex flex-col-reverse sm:flex-row items-stretch sm:items-center justify-center mt-5 gap-3 sm:gap-5">
              <button
                type="button"
                className="bef-btn-secondary w-full sm:w-[150px] min-h-[50px]"
                onClick={closeModal}
              >
                <p className="font-bold">Cancel</p>
              </button>
              <button
                type="submit"
                className="bef-btn-primary w-full sm:w-[150px] min-h-[50px] text-base"
              >
                {loading ? <div className="loader"></div> : "Save"}
              </button>
            </div>
          </form>
        ) : (
          <>
            {children}
            <div className="mt-6 flex justify-center">
              <button
                onClick={closeModal}
                className="bef-btn-primary px-10 py-2.5 w-full sm:w-auto"
              >
                Close
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Model;
